export default "__VITE_ASSET__DiE96dHj__"